export const RESEND_INVITATION = 'agents/RESEND_INVITATION'
export const REVOKE_INVITATION = 'agents/REVOKE_INVITATION'
export const CREATE_INVITATION = 'agents/CREATE_INVITATION'
export const CREATE_INVITATION_BULK = 'agents/CREATE_INVITATION/BULK'
export const UPDATE_USER = 'agents/UPDATE_USER'
export const RESET_PASSWORD = 'agents/RESET_PASSWORD'
export const SAVE_AGENT_DRAFTS = 'agents/SAVE_AGENT_DRAFTS'
export const CLEAR_AGENTS_DRAFTS = 'agents/CLEAR_AGENTS_DRAFTS'
